import { render } from "./StatusPieChart.vue?vue&type=template&id=2848e8de"
import script from "./StatusPieChart.vue?vue&type=script&lang=js"
export * from "./StatusPieChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__